import { render } from "./AboutMe.vue?vue&type=template&id=43cec8de"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Programación\\Desktop\\openbootcamp\\Vuejs\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__